import React from 'react';
import './Footer.scss';
import { FaLinkedin, FaInstagram } from 'react-icons/fa'; // Importing icons from react-icons

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="logo">
          <span><b>ENGLISH</b>ENCLAVE</span>
        </div>
        <div className="email">
          <span>enclaveenglish@gmail.com</span>
        </div>
        <div className="social-links">
          <a 
            href="https://www.linkedin.com/company/englishenclave/?viewAsMember=true" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="social-icon"
          >
            <FaLinkedin />
          </a>
          <a 
            href="https://www.instagram.com/englishenclave_/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="social-icon"
          >
            <FaInstagram />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
